import { WithFirebaseSubscriptions } from 'components/WithFirestoreSubscriptions';
import { observer } from 'mobx-react';
import { StoreProvider } from 'models/utils';
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { AuthenticatedRoute } from 'screens/AuthenticatedRoute';
import './App.css';
import ModalContainer from './components/ModalContainer';
import { ModalManager } from './models/ModalManager';
import LandingPage from './screens/LandingPage';
import LoadingScreen from 'screens/LoadingScreen';
import { Routes } from './constants';

const AuthScreen = lazy(() => import('./screens/AuthScreen'));
const ScoreScreen = lazy(() => import('./screens/ScoreScreen'));
const PlayScreen = lazy(() => import('./screens/PlayScreen'));

const App: React.FC = observer(() => {
  return (
    <div className="App">
      <StoreProvider>
        <WithFirebaseSubscriptions>
          <BrowserRouter>
            <Suspense fallback={<LoadingScreen />}>
              <Switch>
                <AuthenticatedRoute path={Routes.play} component={PlayScreen} />
                <AuthenticatedRoute path={Routes.score} component={ScoreScreen} />
                <Route path={Routes.auth} component={AuthScreen} />
                <Route path={Routes.landing} component={LandingPage} />
              </Switch>
              <ModalContainer isOpen={!!ModalManager.activeModal} children={ModalManager.activeModal} />
            </Suspense>
          </BrowserRouter>
        </WithFirebaseSubscriptions>
      </StoreProvider>
    </div>
  );
});

export default App;
